import APIResult from "@/services/APIResult";

export class ResumeResult extends APIResult {
  constructor() {
    super();
    this.apiData = [];
  }
}
